import { BaseMonitorViewPage } from "./view";
import { Options } from "vue-class-component";
import components from "../../components/component";
import { ElLoading } from "element-plus";
import { getColorFromUUID } from "@/utils";
import { first } from "lodash";

@Options({
  components: components,
})
export class DemoMonitorViewPage extends BaseMonitorViewPage {
  map: any = {
    center: [6.51223, 100.258],
    markerLatLng: [[6.51223, 100.258]],
  };
  async created() {
    this.equipmentId = this.$route.params.id;

    this.equipment = first(
      this.getEquipments().filter(
        (equipment) => equipment.id == this.equipmentId
      )
    );
    this.setTabs();
  }

  getEquipments() {
    return [
      {
        id: "1",
        name: "Dust Analyzer",
        manufacturer: "N/A",
        model: "N/A",
        date_manufactured: new Date(),
        serial_number: "56146",
        measurements: ["PM", "02"],
        configurations: ["DUST 0 - 30 mg/m3", "02 0 - 40 mg/m3"],
        additional: {
          latitude: 6.51223,
          longitude: 100.258,
        },
        sensors: [
          {
            id: 1,
            color: getColorFromUUID("1", 4, ""),
            name: "PM",
            unit: "mg/m3",
            alarm: true,
            message: "Exceeding",
            alarm_type: 77,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
          {
            id: 2,
            color: getColorFromUUID("2", 4, ""),
            name: "02",
            unit: "mg/m3",
            alarm: true,
            message: null,
            alarm_type: null,
            alarm_created_at: null,
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
        ],
      },
      {
        id: "2",
        name: "Energy Meter",
        manufacturer: "N/A",
        model: "N/A",
        date_manufactured: new Date(),
        serial_number: "56146",
        measurements: ["Voltage", "Current"],
        configurations: ["Voltage 0 - 30 V", "Current  0 -  40 A"],
        additional: {
          latitude: 6.51223,
          longitude: 100.261,
        },
        sensors: [
          {
            id: 3,
            color: getColorFromUUID("3", 4, ""),
            name: "Voltage",
            unit: "V",
            alarm: false,
            alarm_type: 0,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
          {
            id: 6,
            color: getColorFromUUID("6", 4, ""),
            name: "Current",
            unit: "A",
            alarm: false,
            alarm_type: 0,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
        ],
      },
      {
        id: "3",
        name: "Water Sensor",
        manufacturer: "N/A",
        model: "N/A",
        date_manufactured: new Date(),
        serial_number: "56146",
        measurements: ["Flow rate", "Chlorine"],
        configurations: ["Flow rate 0 - 30 L/s", "Chlorine  0 -  40 mg/L"],
        additional: {
          latitude: 6.51223,
          longitude: 100.258,
        },
        sensors: [
          {
            id: 4,
            color: getColorFromUUID("4", 4, ""),
            name: "Flow rate",
            unit: "L/s",
            alarm: true,
            message: "Exceeding",
            alarm_type: 0,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
          {
            id: 5,
            color: getColorFromUUID("5", 4, ""),
            name: "Chlorine",
            unit: "mg/L",
            alarm: false,
            message: "Exceeding",
            alarm_type: 78,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
        ],
      },
    ];
  }
}
